'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

({
  /** Link to send the user to when clicked */
  to: PropTypes__default["default"].string.isRequired,
  /** "a" tag to place inside of the link component. Href is copied from "to" prop. But you may also provide href w/o harm to fix . */
  children: PropTypes__default["default"].element.isRequired,
  /** Optional locale string to add to the element */
  locale: PropTypes__default["default"].string || false,
  /** Optional aria-label attribute. */
  ariaLabel: PropTypes__default["default"].string
});
/**
 * Child must be an `a` tag. If `href` is omitted on the `a` tag, it will be
 * passed from `to` prop to `a.href`.
 * If you wish to set an attribute on the `a` tag (like classes), put it on the passed `a`
 * If you want to wrap something, wrap it in your `a` tag.
 * In non-next mode, if `locale` is set, `a` tag will be wrapped in
 */
var Link = function Link(_ref) {
  var _children$props;
  var to = _ref.to,
    children = _ref.children,
    locale = _ref.locale,
    ariaLabel = _ref.ariaLabel;
  // Structured this way so the context can be removed w/o undefined vars.
  ({
    routesContext: {
      isNextRoute: function isNextRoute(url) {
        return false;
      },
      host: '',
      protocol: 'https:',
      baseUrl: '',
      urlObject: new URL('', 'http://localhost')
    }
  });
  // this line is removed by a regex in react-components rollup bc context doesn't exist there. Don't change w/o updating regex.

  // @TODO get locale from URL.
  var validityEnsuredChildren = validateLinkTag(children);
  if (!validityEnsuredChildren) return null;
  var hasHref = !!(children !== null && children !== void 0 && (_children$props = children.props) !== null && _children$props !== void 0 && _children$props.href);
  return /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: /*#__PURE__*/React__default["default"].cloneElement(validityEnsuredChildren, {
      href: hasHref ? children.props.href : to,
      'data-locale': locale,
      'aria-label': ariaLabel
    })
  });
};

/**
 * Ensure that element is a ReactElement (having props) and is also an "a" tag.
 */
var validateLinkTag = function validateLinkTag(children) {
  var _children$type, _children$type$__lina;
  var TARGET_TYPE = 'a';
  if (!('props' in children)) {
    console.error('Invalid tag passed to Link. Must be a single "a" tag. You passed this:', children);
    return false;
  }
  // Verify this is either an `a` tag or an extended `a` tag. Sometimes this can be tricky, as linaria
  // or other styling libs extend the `a` tag. If you get a failure, inspect the logged element in question
  // and you may need to add another check here... a bit of whack-a-mole.
  if (!(children.type === TARGET_TYPE || children.props.originalType === TARGET_TYPE || children.props.mdxType === TARGET_TYPE || ((_children$type = children.type) === null || _children$type === void 0 ? void 0 : (_children$type$__lina = _children$type.__linaria) === null || _children$type$__lina === void 0 ? void 0 : _children$type$__lina["extends"]) === TARGET_TYPE || children.type.endsWith(".".concat(TARGET_TYPE)))) {
    console.error('You passed in a tag that was not an "a" tag. Child of Link must be an "a" tag. You passed this:', children);
    return false;
  }
  return children;
};

exports["default"] = Link;
